import React from 'react';

const DashboardSVG = () => (
  <svg
    height="1em"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.28992 0.539062H14.7053C14.9859 0.539062 15.2144 0.765757 15.2144 1.04418V12.3819C15.2144 12.6603 14.9859 12.887 14.7053 12.887H1.72339C1.44281 12.887 1.21436 12.6603 1.21436 12.3819V1.04418C1.21436 0.765757 1.44281 0.539062 1.72339 0.539062H7.06826"
      stroke="#727272"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M1.21436 2.5625H15.1086"
      stroke="#727272"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M13.0937 6.04557H3.1323C3.05104 6.04557 2.98511 5.97964 2.98511 5.89838V4.405C2.98511 4.32374 3.05104 4.25781 3.1323 4.25781H13.0937C13.175 4.25781 13.2409 4.32374 13.2409 4.405V5.89838C13.2409 5.97964 13.175 6.04557 13.0937 6.04557Z"
      stroke="#727272"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.01413 11.1771H3.1323C3.05104 11.1771 2.98511 11.1112 2.98511 11.0299V7.80247C2.98511 7.7212 3.05104 7.65527 3.1323 7.65527H8.01413C8.09539 7.65527 8.16132 7.7212 8.16132 7.80247V11.0299C8.16132 11.1127 8.09539 11.1771 8.01413 11.1771Z"
      stroke="#727272"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M13.0937 11.1771H10.0257C9.9444 11.1771 9.87848 11.1112 9.87848 11.0299V7.80247C9.87848 7.7212 9.9444 7.65527 10.0257 7.65527H13.0937C13.1749 7.65527 13.2409 7.7212 13.2409 7.80247V11.0299C13.2409 11.1127 13.1749 11.1771 13.0937 11.1771Z"
      stroke="#727272"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default DashboardSVG;
